import { Entry } from '../Entry'

export function Entry20220112() {
  return (
    <Entry title="12/01/2022 - v3.0.0-beta-13">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/12378/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
